import React from 'react';
import Header from './Global/Header';
import Footer from './Global/Footer';
import {Link} from 'react-router-dom';

function Authors(){

return(

    <>
<Header />
{/* // <!-- main content --> */}

	<main class="main">
		<div class="container">
			<div class="row row--grid">
				{/* <!-- breadcrumb --> */}
				<div class="col-12">
					<ul class="breadcrumb">
						<li class="breadcrumb__item"><Link to="/">Home</Link></li>
						<li class="breadcrumb__item breadcrumb__item--active">Authors</li>
					</ul>
				</div>
				{/* <!-- end breadcrumb --> */}

				{/* <!-- title --> */}
				<div class="col-12">
					<div class="main__title main__title--page">
						<h1>Top Rated Authors</h1>
					</div>
				</div>
				{/* <!-- end title --> */}

				{/* <!-- filter --> */}
				<div class="col-12">
					<div class="main__filter">
						<form action="#" class="main__filter-search">
							<input type="text" placeholder="Search for a creator…" />
							<button type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"/></svg></button>
						</form>

						<div class="main__filter-wrap">
							<select class="main__select" name="status">
								<option value="rating">By rating</option>
								<option value="views">By views</option>
								<option value="popularity">By popularity</option>
							</select>

							<select class="main__select" name="authors">
								<option value="0">All Authors</option>
								<option value="1">Verified only</option>
							</select>
						</div>
					</div>
				</div>
				{/* <!-- end filter --> */}
			</div>

			{/* <!-- authors --> */}
			<div class="row row--grid">
				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
						<Link to="/author" class="author__cover author__cover--bg" data-bg={'images/bg-small.png'}>
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller1.jpg" alt="" />
								</Link>
							<h3 class="author__name"><Link to="/author">Adam Zapel</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@aaarthur</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>3829</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
					<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small2.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller2.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Barb E. Dahl</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@nicky87</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>4602</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
						<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small3.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller3.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Biff Wellington</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@neo</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>1294</p>
									<span>Followers</span>
								</div>
								<button class="author__follow author__follow--true" type="button">Unfollow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
						<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller4.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Charity Case</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@midinh</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>10 845</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
					<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small5.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller5.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Don Key</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@kateblank</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>9713</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
						<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small4.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller6.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Mona Lott</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@fantraingle</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>5 924</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
						<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small5.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar">
								<img src="/images/seller7.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Orson Carte</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@sc00ty</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>11 342</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
					<div class="author">
						<Link to="/author" class="author__cover author__cover--bg" data-bg="/images/bg-small6.png">
						</Link>
						<div class="author__meta">
							<Link to="/author" class="author__avatar author__avatar--verified">
								<img src="/images/seller8.jpg" alt="" />
							</Link>
							<h3 class="author__name"><Link to="/author">Ray Gunn</Link></h3>
							<h3 class="author__nickname"><Link to="/author">@justart</Link></h3>
							<p class="author__text">Many desktop publishing packages and web page editors now use Lorem</p>
							<div class="author__wrap">
								<div class="author__followers">
									<p>1245</p>
									<span>Followers</span>
								</div>
								<button class="author__follow" type="button">Follow</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <!-- end authors --> */}

			{/* <!-- paginator --> */}
			<div class="row row--grid">
				<div class="col-12">
					<div class="paginator">
						<span class="paginator__pages">8 from 169</span>

						<ul class="paginator__list">
							<li>
								<a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"/></svg></a>
							</li>
							<li class="active"><Link to="/authors">1</Link></li>
							<li><Link to="/authors">2</Link></li>
							<li><Link to="/authors">3</Link></li>
							<li><Link to="/authors">4</Link></li>
							<li>
								<a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			{/* <!-- end paginator --> */}
		</div>
	</main>
	{/* <!-- end main content --> */}

<Footer />
    </>

);


}

export default Authors;